import { useCityStore } from '~/features/store/cities';

export default defineNuxtPlugin(() => {
  const { getCities } = useCityStore();
  getCities();
});
